import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <Section background="cream" id="offer" className="text-center" data-id="element-62">
      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-[#E8DED3] max-w-2xl mx-auto relative overflow-hidden" data-id="element-63">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#D4735E] to-[#8B9D83]" data-id="element-64"></div>

        <h2 className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4" data-id="element-65">
          Menopausia Sin Caos
        </h2>
        <p className="text-[#8B9D83] font-medium tracking-wide uppercase mb-8" data-id="element-66">
          El Sistema 10–10–10
        </p>

        <div className="flex items-center justify-center mb-8" data-id="element-67">
          <span className="text-6xl font-bold text-[#2C2C2C]" data-id="element-68">$6.39</span>
          <span className="text-gray-400 ml-2 text-xl line-through" data-id="element-69">
            $27.00
          </span>
        </div>

        <Button fullWidth className="mb-6 text-xl py-5 shadow-lg shadow-[#D4735E]/20" data-id="element-70">
          Descargar Ahora
        </Button>

        <div className="flex items-center justify-center text-sm text-[#5A5A5A] gap-2" data-id="element-71">
          <ShieldCheck className="h-4 w-4 text-[#8B9D83]" data-id="element-72" />
          <span data-id="element-73">Pago seguro y descarga inmediata</span>
        </div>
      </div>
    </Section>;
}